module.exports = __webpack_public_path__ + "fonts/la-solid-900.36fc297.woff2";